import React from "react";
import { createRoot } from "react-dom/client";
import { createBrowserHistory } from "history";
import { Router, Route, Switch } from "react-router-dom";
import ReactGA from 'react-ga4';
import withTracker from "utils/withTracker";
import { Analytics } from "@vercel/analytics/react";

import "assets/scss/material-kit-react.scss?v=1.8.0";

// pages for this product
// import Components from "views/Components/Components.js";
import LandingPage from "views/LandingPage/LandingPage.js";
import ImpressumPage from "views/Contact/ImpressumPage.js";
import PrivacyPage from "views/Contact/PrivacyPage.js";
// import LoginPage from "views/LoginPage/LoginPage.js";
import CosCertPage from "views/Cosmetics/CosCertPage.js";
import PhenoxyethanolPage from "views/Cosmetics/PhenoxyethanolPage.js";
import DetCertPage from "views/Detergents/DetCertPage.js";
import PackPage from "views/Packaging/PackPage.js";
import GranulePage from "views/Granules/GranulePage.js";
import SearchPage from "views/Database/SearchPage.js";
import ClaimCheckPage from "views/ClaimCheck/ClaimCheckPage.js";
import Certificate from "views/LandingPage/Certificate.js";
import HowMuchLaundryDetergentShouldYouUse from "views/Detergents/HowMuchLaundryDetergentShouldYouUse.js";
import InvalidCertPage from "views/InvalidCert/InvalidCertPage.js";
import ProductPage from "views/Product/ProductPage.js";
import BrandPage from "views/Brand/BrandPage.js";
import AdminEntry from "admin/AdminEntry.js";

var hist = createBrowserHistory();

const TRACKING_ID = "G-GPX0DR1JT8";

ReactGA.initialize(TRACKING_ID, {
  debug: false,
});

// ReactGA.initialize("UA-186047649-1", {
//   debug: false,
// });

    // useEffect(() => {
    //   ReactGA.initialize(TRACKING_ID);
    //   ReactGA.send({
    //     hitType: "pageview",
    //     page: "/",
    //     title: "Landing Page",
    //   });
    // }, []);

createRoot(document.getElementById("root")).render(
    <>
    <Router history={hist}>
      <Switch>
        <Route path="/cert55" component={Certificate} />
        <Route path="/cosmetics" component={withTracker(CosCertPage)} />
        <Route path="/detergents" component={withTracker(DetCertPage)} />
        <Route path="/packaging" component={withTracker(PackPage)} />
        <Route path="/granules" component={withTracker(GranulePage)} />
        <Route
          path="/phenoxyethanol"
          component={withTracker(PhenoxyethanolPage)}
        />
        <Route
          path="/HowMuchLaundryDetergentShouldYouUse"
          component={withTracker(HowMuchLaundryDetergentShouldYouUse)}
        />

        {/* <Route path="/components55" component={withTracker(Components)} /> */}
        {/* <Route path="/landing-page" component={withTracker(LandingPage)} /> */}
        <Route path="/impressum" component={withTracker(ImpressumPage)} />
        <Route path="/privacy" component={withTracker(PrivacyPage)} />
        {/* <Route path="/login-page" component={LoginPage} /> */}
        <Route path="/claim-check" component={withTracker(ClaimCheckPage)} />
        <Route path="/search" component={withTracker(ClaimCheckPage)} />
        <Route path="/invalid-cert" component={withTracker(InvalidCertPage)} />
        <Route path="/p/:authId" component={withTracker(ProductPage)} />
        <Route path="/brand/:authId" component={withTracker(BrandPage)} />
        <Route path="/product/:authId" component={withTracker(ProductPage)} />
        <Route path="/admin" component={AdminEntry} />
        <Route path="/" component={withTracker(LandingPage)} />
      </Switch>
    </Router>
    <Analytics />
    </>
);
